export default {
    primary: '#4a6da7',
    primaryDarker: '#2b436b',
    primaryLighter: '#7d93b8',
    mainBackground: '#eceae7',
    footerBackground: '#373433',
};
